import(/* webpackMode: "eager" */ "/mnt/store/clusterdev/manglish-desh-web/app/(routes)/(index)/page.tsx");
